import { UseQueryOptions, useQuery } from "@tanstack/react-query";
import axiosAuth from "../../../axiosAuth";
import { CRM_CLASS_BY_SCHOOL_ID } from "../../apiRoutes";

export interface CrmClassSection {
  _id?: string;
  name: string;
  noOfStudent: number;
}

export interface CrmClassData {
  _id: string;
  schoolId: string;
  curriculumId: string;
  year: string;
  section: CrmClassSection[];
  createdAt: string;
  updatedAt: string;
}

export interface CrmClassPagination {
  totalRecords: number;
  totalPages: number;
  currentPage: number;
  pageSize: number;
}

export interface CrmClassResponse {
   data: {
    records: CrmClassData[];
    pagination: { totalRecords: number }[];
  }[];
  // data: CrmClassData[];
  // pagination: CrmClassPagination;
}

export interface CrmClassQueryParams {
  page?: number;
  limit?: number;
  school?: string;
}

const fetchCrmClass = async (params: CrmClassQueryParams) => {
  const { school, page = 1, limit = 10 } = params;
  const response = await axiosAuth.get<CrmClassResponse>(
    `${CRM_CLASS_BY_SCHOOL_ID}${school}/`,
    {
      params: {
        page,
        limit,
      },
    }
  );
  return response.data;
};

export const useGetCrmClassQuery = (
  params: CrmClassQueryParams,
  queryOptions?: Omit<
    UseQueryOptions<
      CrmClassResponse,
      Error,
      CrmClassResponse,
      ["crm-class", CrmClassQueryParams]
    >,
    "queryKey" | "queryFn"
  >
) =>
  useQuery<CrmClassResponse, Error, CrmClassResponse, ["crm-class", CrmClassQueryParams]>({
    queryKey: ["crm-class", params],
    queryFn: () => fetchCrmClass(params),
    enabled: !!params.school,
    ...(queryOptions || {}),
  });
